import React from "react";
import { isServer } from "@/lib/commonService";
import { getGlobal } from "@/src/utils";

interface IVisitor {
  name?: string;
  email?: string;
}

interface IParams {
  name?: string;
  value?: any;
}

interface IProps {
  // important
  license: number;
  isNew?: boolean;
  group?: number;
  onChatLoaded?: Function;
  // less important
  params?: IParams[];
  visitor?: IVisitor[];
  chatBetweenGroups?: boolean;
  onBeforeLoad?: Function;
  onAfterLoad?: Function;
  onChatWindowOpened?: Function;
  onChatWindowMinimized?: Function;
  onChatWindowHidden?: Function;
  onChatStateChanged?: Function;
  onChatStarted?: Function;
  onChatEnded?: Function;
  onMessage?: Function;
  onTicketCreated?: Function;
  onPrechatSurveySubmitted?: Function;
  onPostchatSurveySubmitted?: Function;
  onRatingSubmitted?: Function;
  onRatingCommentSubmitted?: Function;
  onErrorLoading?: Function;
}

interface IState {}

export default class LiveChat extends React.Component<IProps, IState> {
  maximize = false;
  static lc: any = null;

  componentDidMount() {
    this.loadLiveChatApi.bind(this)();

    if (!isServer) {
      const container = document.getElementById("chat-widget-container");
      if (container) {
        container.style.display = "block";
      }
    }
  }

  chatLoaded() {
    if (getGlobal().LC_API) {
      this.setCallbacks.bind(this)();
      if (typeof this.props.onChatLoaded === "function") {
        this.props.onChatLoaded(getGlobal().LC_API);
      }
    }
    if (getGlobal().$_REVECHAT_API) {
      this.setCallbacks.bind(this)();
      if (typeof this.props.onChatLoaded === "function") {
        this.props.onChatLoaded(getGlobal().$_REVECHAT_API);
      }
    }
  }

  chatNotLoaded() {
    if (typeof this.props.onErrorLoading === "function") {
      this.props.onErrorLoading();
    }
  }

  loadLiveChatApi() {
    let chatUrl: any;
    if (this.props.isNew) {
      if (!getGlobal().$_REVECHAT_API) {
        getGlobal().__revechat_account = this.props.license;
        getGlobal().__revechat_version = 2;
        chatUrl =
          ("https:" == document.location.protocol ? "https://" : "http://") +
          "static.revechat.com/widget/scripts/new-livechat.js";
        getGlobal().LC_API = {
          open_chat_window: () => {
            getGlobal().$_REVECHAT_API.Button.maximize();
            this.maximize = true;
          },
          chat_window_minimized: () => {
            return !this.maximize;
          },
          chat_running: () => {
            return this.maximize;
          },
          trigger_sales_tracker() {},
        };
      }
    } else {
      if (!getGlobal().LC_API) {
        getGlobal().__lc = getGlobal().__lc || {};
        getGlobal().__lc.license = this.props.license;
        getGlobal().__lc.group = this.props.group;
        getGlobal().__lc.chat_between_groups = this.props.chatBetweenGroups;
        getGlobal().__lc.params = this.props.params;
        getGlobal().__lc.visitor = this.props.visitor;
        chatUrl =
          ("https:" === document.location.protocol ? "https://" : "http://") +
          "cdn.livechatinc.com/tracking.js";
      }
    }
    if (!LiveChat.lc) {
      LiveChat.lc = document.createElement("script");
      LiveChat.lc.type = "text/javascript";
      LiveChat.lc.async = true;
      LiveChat.lc.src = chatUrl;
      const s: any = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(LiveChat.lc, s);
      LiveChat.lc.addEventListener("load", this.chatLoaded.bind(this));
      LiveChat.lc.addEventListener("error", this.chatNotLoaded.bind(this));
    }
  }

  render() {
    return null;
  }

  setCallbacks() {
    if (typeof this.props.onBeforeLoad === "function")
      getGlobal().LC_API.on_before_load = this.props.onBeforeLoad.bind(this);

    if (typeof this.props.onAfterLoad === "function")
      getGlobal().LC_API.on_after_load = this.props.onAfterLoad.bind(this);

    if (typeof this.props.onChatWindowOpened === "function")
      getGlobal().LC_API.on_chat_window_opened =
        this.props.onChatWindowOpened.bind(this);

    if (typeof this.props.onChatWindowMinimized === "function")
      getGlobal().LC_API.on_chat_window_minimized =
        this.props.onChatWindowMinimized.bind(this);

    if (typeof this.props.onChatWindowHidden === "function")
      getGlobal().LC_API.on_chat_window_hidden =
        this.props.onChatWindowHidden.bind(this);

    if (typeof this.props.onChatStateChanged === "function")
      getGlobal().LC_API.on_chat_state_changed =
        this.props.onChatStateChanged.bind(this);

    if (typeof this.props.onChatStarted === "function")
      getGlobal().LC_API.on_chat_started = this.props.onChatStarted.bind(this);

    if (typeof this.props.onChatEnded === "function")
      getGlobal().LC_API.on_chat_ended = this.props.onChatEnded.bind(this);

    if (typeof this.props.onMessage === "function")
      getGlobal().LC_API.on_message = this.props.onMessage.bind(this);

    if (typeof this.props.onTicketCreated === "function")
      getGlobal().LC_API.on_ticket_created =
        this.props.onTicketCreated.bind(this);

    if (typeof this.props.onPrechatSurveySubmitted === "function")
      getGlobal().LC_API.on_prechat_survey_submitted =
        this.props.onPrechatSurveySubmitted.bind(this);

    if (typeof this.props.onRatingSubmitted === "function")
      getGlobal().LC_API.on_rating_submitted =
        this.props.onRatingSubmitted.bind(this);

    if (typeof this.props.onRatingCommentSubmitted === "function")
      getGlobal().LC_API.on_rating_comment_submitted =
        this.props.onRatingCommentSubmitted.bind(this);
  }
}
